import React from "react";

interface IProps {
	className?: string;
	fillOne?: string;
	fillTwo?: string;
	fillThree?: string;
}

export const Promotion = ({ className, fillOne, fillTwo, fillThree }: IProps) => {
	return (
		<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			<path
				d="M28.5 15C28.5102 14.0222 28.2123 13.066 27.6484 12.2671C27.0845 11.4682 26.2834 10.8672 25.3586 10.5493C25.799 9.66742 25.9572 8.6713 25.8117 7.69635C25.6662 6.72139 25.224 5.81488 24.5453 5.1C23.8834 4.40227 23.0102 3.94174 22.0606 3.78945C21.1109 3.63716 20.1376 3.80158 19.2906 4.25733C19.0291 3.32044 18.4682 2.49489 17.6934 1.90676C16.9186 1.31863 15.9727 1.00026 15 1.00026C14.0273 1.00026 13.0813 1.31863 12.3065 1.90676C11.5318 2.49489 10.9708 3.32044 10.7093 4.25733C9.86212 3.8017 8.88859 3.63735 7.93877 3.78963C6.98896 3.94191 6.1156 4.40235 5.45331 5.1C4.77481 5.81503 4.3329 6.72161 4.18762 7.69656C4.04234 8.67151 4.20075 9.66755 4.64131 10.5493C3.72231 10.8759 2.92697 11.479 2.36453 12.2758C1.80208 13.0726 1.50012 14.024 1.50012 14.9993C1.50012 15.9746 1.80208 16.926 2.36453 17.7228C2.92697 18.5196 3.72231 19.1227 4.64131 19.4493C4.20075 20.3311 4.04234 21.3271 4.18762 22.3021C4.3329 23.277 4.77481 24.1836 5.45331 24.8987C6.11544 25.5965 6.98872 26.0572 7.93854 26.2097C8.88836 26.3623 9.86198 26.1981 10.7093 25.7427C10.9708 26.6796 11.5318 27.5051 12.3065 28.0932C13.0813 28.6814 14.0273 28.9997 15 28.9997C15.9727 28.9997 16.9186 28.6814 17.6934 28.0932C18.4682 27.5051 19.0291 26.6796 19.2906 25.7427C20.1377 26.1983 21.1112 26.3625 22.0608 26.2099C23.0104 26.0574 23.8835 25.5966 24.5453 24.8987C25.224 24.1838 25.6662 23.2773 25.8117 22.3023C25.9572 21.3274 25.799 20.3312 25.3586 19.4493C26.2833 19.1317 27.0844 18.5309 27.6483 17.7323C28.2121 16.9336 28.5101 15.9776 28.5 15V15Z"
				stroke={fillOne ?? "#FBCD21"}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M10.5 20L20.5 10" stroke={fillTwo ?? "#FBCD21"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M9.5 11C9.5 11.5304 9.71071 12.0391 10.0858 12.4142C10.4609 12.7893 10.9696 13 11.5 13C12.0304 13 12.5391 12.7893 12.9142 12.4142C13.2893 12.0391 13.5 11.5304 13.5 11C13.5 10.4696 13.2893 9.96086 12.9142 9.58579C12.5391 9.21071 12.0304 9 11.5 9C10.9696 9 10.4609 9.21071 10.0858 9.58579C9.71071 9.96086 9.5 10.4696 9.5 11V11Z"
				stroke={fillTwo ?? "#FBCD21"}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.5 19C17.5 19.5304 17.7107 20.0391 18.0858 20.4142C18.4609 20.7893 18.9696 21 19.5 21C20.0304 21 20.5391 20.7893 20.9142 20.4142C21.2893 20.0391 21.5 19.5304 21.5 19C21.5 18.4696 21.2893 17.9609 20.9142 17.5858C20.5391 17.2107 20.0304 17 19.5 17C18.9696 17 18.4609 17.2107 18.0858 17.5858C17.7107 17.9609 17.5 18.4696 17.5 19V19Z"
				stroke={fillThree ?? "#FBCD21"}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
